
import { useState } from 'react';

function useSelectItem(props) {
  const { defaultValue, validItems } = props
  const [selectedItems, setSelectedItems] = useState(defaultValue);

  const selectItem = (evt, data) => {
    let newSelectedItems = [];
    if (selectedItems.includes(data.value)) {
      newSelectedItems = selectedItems.filter(item => item !== data.value)
      setSelectedItems(newSelectedItems)
    } else {
      newSelectedItems = [...selectedItems]
      newSelectedItems.push(data.value)
      setSelectedItems(newSelectedItems)
    }
  }

  const filterItems = (evt, data) => {
    let newSelectedItems = [];
    newSelectedItems = data.value.filter(item => validItems.includes(item));
    setSelectedItems(newSelectedItems);
  }

  return [ selectedItems, selectItem, filterItems, setSelectedItems ]

}

export default useSelectItem




// WEBPACK FOOTER //
// ./src/views/project_control_register/use_select_item.js